import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";
import { ADDRESS_ONE_LINE, BUSINESS } from "@/lib/site";

export function AboutWelcome() {
  const photo = PHOTOS.parkModelPatio;

  return (
    <section
      className="texture-paper bg-background py-24 sm:py-28 lg:py-36"
      aria-labelledby="welcome-title"
    >
      <div className="mx-auto grid max-w-[1400px] gap-14 px-4 sm:px-6 lg:grid-cols-[1fr_1.05fr] lg:items-center lg:gap-20 lg:px-10">
        <div>
          <Reveal>
            <p className="eyebrow text-clay">Welcome to Amigo Inn</p>
            <h2
              id="welcome-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              A Place Where Guests Can Settle In and Feel at Home
            </h2>
          </Reveal>

          <Reveal
            delay={0.08}
            className="mt-6 space-y-5 text-base leading-relaxed text-muted-foreground sm:text-lg"
          >
            <p>
              At Amigo Inn &amp; RV Park, hospitality is personal. We have created a peaceful place
              where guests can slow down, enjoy the South Texas sunsets, and feel
              comfortable—whether they are staying for a weekend, a fishing trip, a work assignment,
              the winter season, or something longer.
            </p>
            <p>
              Located at {BUSINESS.street} in {BUSINESS.city}, the park is near public boat access
              and approximately three miles from town. Guests can enjoy a quiet campground
              atmosphere while remaining close to the conveniences, restaurants, culture, and
              attractions of {BUSINESS.city}.
            </p>
            <p>
              Our team takes pride in welcoming every guest and providing the friendly, down-home
              experience that makes Amigo Inn feel like more than simply a place to park or spend
              the night.
            </p>
          </Reveal>

          <Reveal delay={0.14} className="mt-8">
            <p className="text-sm font-semibold text-forest-deep">{ADDRESS_ONE_LINE}</p>
          </Reveal>
        </div>

        <MaskReveal className="media-zoom rounded-sm">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes={PHOTO_SIZES.half}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[4/3] w-full rounded-sm object-cover"
          />
        </MaskReveal>
      </div>
    </section>
  );
}
